import React from 'react';

import styled, { css } from 'styled-components';

import { Skeleton } from 'fpay-ui';
import { SkeletonAmountCard, OperationSkeletonTable, SkelettonBanner } from '@components';

const LayoutAmountCard = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    ${theme.breakpoint('md')} {
      flex-direction: row;
      justify-content: space-between;
  `
);

const SkeletonTitle = styled(Skeleton)(
  ({ theme }) => css`
    max-width: 97px;
    height: 19px;
    margin-top: 29px;
    margin-bottom: 24px;
    ${theme.breakpoint('ll')} {
      max-width: ${(props) => (props.large ? '313px' : '97px')};
    }
  `
);

const SkeletonButton = styled(Skeleton)(
  ({ theme }) => css`
    width: 104px;
    height: 55px;
    margin-top: 24px;
    margin-bottom: 0;
    ${theme.breakpoint('md')} {
      height: 40px;
    }
    ${theme.breakpoint('ll')} {
      width: 104px;
    }
  `
);

const HomeScreenSkeleton = () => (
  <>
    <SkeletonTitle />
    <SkelettonBanner />
    <SkeletonTitle />
    <LayoutAmountCard>
      <SkeletonAmountCard />
      <SkeletonAmountCard />
      <SkeletonAmountCard />
    </LayoutAmountCard>
    <SkeletonTitle large />
    <OperationSkeletonTable />
    <SkeletonButton />
  </>
);
export default HomeScreenSkeleton;
